import Banner from "../../sections/common/banner";
import SectionServices from "../../sections/services/maritime-law-service/section-services";
import { data as dataEs } from "../../../globals/data/es/operacionesSTSServices.js";
import { data as dataEn } from "../../../globals/data/en/operacionesSTSServices.js";
import { data as dataCn } from "../../../globals/data/zh/operacionesSTSServices.js";
import { useLangagesStore } from "../../../context/langages";

export default function OperationsSTSService() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEn : language === "cn" ? dataCn : dataEs;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionServices _data={data.features} />
        </>
    )
}